import { StatisticsService } from '@api'
import { useUnit } from 'effector-react'
import { useQuery } from 'react-query'

import {
  getDateInTimezone,
  parseStringDate,
} from '@/components/ui/calendar/utils'
import { $account } from '@/models/account.ts'
import { useAccount } from '@/modules/accounts/hooks/useAccounts.ts'
import type { Creator } from '@/modules/creators/types.ts'

export const useMaxDateRange = (creator: Creator | null) => {
  const account = useUnit($account)
  const { isLoggedIn } = useAccount()
  const today = getDateInTimezone(account?.timezone)

  return useQuery(
    ['range', creator?.id ?? 0],
    async () => {
      const range = await StatisticsService.findStatisticsRange({
        creatorId: creator?.id ?? undefined,
      })
      let from = parseStringDate(range.from, today)
      const to = parseStringDate(range.to, today)

      if (from?.getTime() === to?.getTime()) {
        from = new Date(0)
      }

      return { from, to }
    },
    {
      enabled: isLoggedIn,
      refetchInterval: 60000,
      initialData: { from: new Date(0), to: today },
      onError: (error) => {
        // Do not show error toast
        console.error('Error fetching max date range:', error)
      },
    },
  )
}
